module.exports = __webpack_public_path__ + "assets/ae09798e9ba6cea8c654e08862aa5ddb.mp3";